import { render, staticRenderFns } from "./vRecipeCategoryPrintout.vue?vue&type=template&id=325e5ab6&scoped=true"
import script from "./vRecipeCategoryPrintout.vue?vue&type=script&lang=ts"
export * from "./vRecipeCategoryPrintout.vue?vue&type=script&lang=ts"
import style0 from "./vRecipeCategoryPrintout.vue?vue&type=style&index=0&id=325e5ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325e5ab6",
  null
  
)

export default component.exports